import React from 'react';

const PhotoCard = ({
    src
}) => {
  return (
    <img src={src} style={{ width: "100%" }} />

  );
}

export default PhotoCard;
